import styled from "styled-components";
import { colors } from "../../theme/colors";

export const Main = styled.main`
  @media (min-width: 996px) {
    padding-top: 62px;
  }
  color: ${colors.greenDark};
`;
